import React from "react";

const PingMePrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-40">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy for PingMe Back in Stock</h1>
      <p className="mb-4"><strong>Effective Date:</strong> 16-04-2025</p>
      <p className="mb-6">
        Welcome to PingMe Back in Stock! Your privacy is important to us, and we are committed
        to protecting the personal information you share with us. This Privacy Policy explains
        how we collect, use, and safeguard your data when you use our Shopify app.
      </p>

      <h2 className="text-2xl font-semibold mb-4">1. Information We Collect</h2>
      <p className="mb-2">When you install and use PingMe Back in Stock, we may collect:</p>

      <h3 className="text-xl font-medium mb-2">1.1 Shopify Store Information</h3>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Store name</li>
        <li>Store URL</li>
        <li>Shopify store ID</li>
        <li>Shopify plan details</li>
      </ul>

      <h3 className="text-xl font-medium mb-2">1.2 User Information</h3>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Shopify account email</li>
        <li>Store owner name (if applicable)</li>
        <li>Contact details provided via customer support</li>
      </ul>

      <h3 className="text-xl font-medium mb-2">1.3 App Usage Data</h3>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Product and inventory status (to enable restock alerts)</li>
        <li>Notification request details (email addresses of customers who opt in for alerts)</li>
        <li>Activity logs related to feature usage</li>
      </ul>
      <p className="mb-6">
        ⚠️ <strong>Note:</strong> We do not collect or store customer payment details, financial
        data, or sensitive personal information from your Shopify store.
      </p>

      <h2 className="text-2xl font-semibold mb-4">2. How We Use Your Information</h2>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Provide and improve PingMe Back in Stock functionality</li>
        <li>Send restock notifications to customers who request them</li>
        <li>Offer customer support and respond to inquiries</li>
        <li>Improve app performance and user experience</li>
        <li>Monitor stability and troubleshoot issues</li>
      </ul>
      <p className="mb-6">
        We do not sell or share your data with third parties for marketing purposes.
      </p>

      <h2 className="text-2xl font-semibold mb-4">3. Data Storage & Security</h2>
      <p className="mb-6">
        Data is stored securely on encrypted servers. Industry-standard security measures are
        applied to prevent unauthorized access, disclosure, or modification. While we work hard
        to protect your information, no method of internet transmission is 100% secure.
      </p>

      <h2 className="text-2xl font-semibold mb-4">4. Third-Party Services</h2>
      <p className="mb-6">
        PingMe Back in Stock integrates with Shopify and uses its API to access store data.
        Shopify’s privacy policies apply when using our app. Please review Shopify’s Privacy
        Policy. If we integrate additional third-party services, we will ensure they comply
        with relevant data protection laws.
      </p>

      <h2 className="text-2xl font-semibold mb-4">5. Data Retention & Deletion</h2>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>We retain data only as long as necessary to provide our services.</li>
        <li>If you uninstall PingMe Back in Stock, your store data will be deleted within 30 days, unless required for legal or compliance reasons.</li>
        <li>You may request data deletion by contacting us at <a href="mailto:support@mean3.com" className="text-blue-500 hover:underline">support@mean3.com</a>.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">6. Your Rights</h2>
      <p className="mb-2">You have the right to:</p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Access and review the data we store about you</li>
        <li>Request corrections or updates to your data</li>
        <li>Request deletion of your data (subject to legal obligations)</li>
      </ul>
      <p className="mb-6">For any requests, please contact us at <a href="mailto:support@mean3.com" className="text-blue-500 hover:underline">support@mean3.com</a>.</p>

      <h2 className="text-2xl font-semibold mb-4">7. Cookies & Tracking</h2>
      <p className="mb-6">
        We do not use cookies to track user behavior. However, Shopify may use cookies in
        connection with our app’s operation. Please refer to Shopify’s cookie policy for details.
      </p>

      <h2 className="text-2xl font-semibold mb-4">8. Changes to This Policy</h2>
      <p className="mb-6">
        We may update this Privacy Policy from time to time. Any updates will be posted on this
        page with the revised effective date. If significant changes affect your rights, we will
        notify you via email or app notification.
      </p>

      <h2 className="text-2xl font-semibold mb-4">9. Contact Us</h2>
      <p className="mb-2">If you have any questions about this Privacy Policy, please contact us:</p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li><strong>Email:</strong> <a href="mailto:support@mean3.com" className="text-blue-500 hover:underline">support@mean3.com</a></li>
      </ul>
    </div>
  );
};

export default PingMePrivacyPolicy;
